module.exports = __webpack_public_path__ + "static/background-a0690b4308ffea08565cce1f84f8ff01.jpg";